<template>
	<div
		:class="{
			container: true,
			'container-on': props.value
		}"
	>
		<div
			:class="{
				switcher: true,
				'switcher--on': props.value
			}"
		/>
	</div>
</template>

<script setup lang="ts">
const props = defineProps<{
	value?: boolean;
}>();
</script>

<style scoped>
.container {
	overflow: hidden;
	border-radius: var(--size-m);

	position: relative;
	background-color: var(--background-color);

	height: var(--size-l);
	width: var(--size-xxl);

	transition: all 0.3s ease-out;

	cursor: pointer;

	/* outline: 2px solid var(--hint-color); */
}

.container-on {
	background-color: var(--success-color);
}

.switcher {
	border-radius: var(--size-m);

	width: var(--size-m);
	height: var(--size-m);

	background-color: var(--text-color);

	transform: translate(25%, 25%);

	transition: all 0.3s ease-out;
}

.switcher--on {
	transform: translate(125%, 25%);
}
</style>
